import { MenuOption } from 'components/common/DropdownList'
import { history, routePath } from 'routes'
import { Props } from './index'

export const AdminOptions = (props: Props): MenuOption[] => {
  return [
    {
      text: 'Manage CPT4',
      onClick: () => history.push(routePath.CPT4_LIST)
    },
    {
      text: 'Most Active CPT4',
      onClick: () => history.push(routePath.MOST_ACTIVE_CPT4_LIST)
    },
    // {
    //   text: 'Logout',
    //   onClick: () => props.logout()
    // }
  ]
}

export default AdminOptions